/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBallBasketball = createReactComponent("ball-basketball", "IconBallBasketball", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M5.65 5.65l12.7 12.7", key: "svg-1" }],
  ["path", { d: "M5.65 18.35l12.7 -12.7", key: "svg-2" }],
  ["path", { d: "M12 3a9 9 0 0 0 9 9", key: "svg-3" }],
  ["path", { d: "M3 12a9 9 0 0 1 9 9", key: "svg-4" }]
]);

export { IconBallBasketball as default };
//# sourceMappingURL=IconBallBasketball.js.map
